module.exports = __webpack_public_path__ + "static/media/mask.bd2cf6c1.png";